import PropTypes from 'prop-types';

const CashFlowSvg = ({ width, height, palette = [] }) => {
  return (
    <svg
      width={`${width || 70}`}
      height={`${height || 70}`}
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_713_11356)">
        <path
          d="M35 56.1914C23.3149 56.1914 13.8086 46.6849 13.8086 35C13.8086 23.3151 23.3149 13.8086 35 13.8086C46.6851 13.8086 56.1914 23.3151 56.1914 35C56.1914 46.6849 46.6851 56.1914 35 56.1914Z"
          fill="url(#paint0_linear_713_11356)"
        />
        <path
          d="M37.7855 32.9562C37.5434 32.8706 37.2976 32.7823 37.0511 32.6921V27.7592C37.3656 27.9211 37.5193 28.0462 37.5393 28.0633C37.9047 28.4006 38.3932 28.6084 38.9297 28.6084C40.0623 28.6084 40.9805 27.6902 40.9805 26.5576C40.9805 25.9615 40.7247 25.4265 40.3186 25.0519L40.3201 25.0503C39.6979 24.4762 38.5491 23.7699 37.0511 23.4324V22.6953C37.0511 21.5627 36.1329 20.6445 35.0003 20.6445C33.8677 20.6445 32.9495 21.5627 32.9495 22.6953V23.5677C32.9096 23.5791 32.8701 23.5892 32.83 23.6012C30.6414 24.2605 29.0073 26.1259 28.5657 28.4692C28.1587 30.6284 28.8658 32.7227 30.411 33.9347C31.0815 34.4605 31.8901 34.9435 32.9495 35.4401V42.3235C32.3494 42.1889 31.8251 41.9282 31.0639 41.4302C30.116 40.81 28.8449 41.0758 28.2249 42.0237C27.6049 42.9715 27.8705 44.2425 28.8184 44.8626C30.3859 45.888 31.5485 46.3132 32.9494 46.4732V47.3047C32.9494 48.4373 33.8676 49.3555 35.0001 49.3555C36.1327 49.3555 37.0509 48.4373 37.0509 47.3047V46.2738C38.1272 45.9681 39.1084 45.4203 39.9495 44.6474C41.1618 43.5337 41.9799 42.0247 42.2532 40.3988C42.8099 37.0884 41.0144 34.0975 37.7855 32.9562ZM32.9495 30.7126C32.9472 30.7109 32.9447 30.7091 32.9424 30.7074C32.6169 30.4522 32.4778 29.8579 32.5963 29.229C32.6274 29.0644 32.7187 28.6996 32.9495 28.3414V30.7126ZM38.2087 39.7187C38.087 40.442 37.6961 41.197 37.0512 41.7309V37.115C38.3467 37.8827 38.3033 39.156 38.2087 39.7187ZM16.3134 25.0143L7.35355 16.0545L3.50082 19.9072C2.20896 21.1991 0 20.2841 0 18.457V2.05078C0 0.918203 0.918203 0 2.05078 0H18.457C20.2841 0 21.1991 2.20896 19.9072 3.50096L16.0545 7.35369L25.0143 16.3136C21.3279 18.2913 18.2913 21.328 16.3134 25.0143ZM25.0143 53.6866L16.0545 62.6464L19.9072 66.4992C21.1991 67.791 20.2841 70 18.457 70H2.05078C0.918203 70 0 69.0818 0 67.9492V51.543C0 49.7159 2.20896 48.8009 3.50096 50.0928L7.35369 53.9455L16.3136 44.9857C18.2913 48.672 21.3279 51.7087 25.0143 53.6866ZM62.6463 16.0545L53.6864 25.0143C51.7085 21.328 48.672 18.2915 44.9857 16.3136L53.9455 7.35369L50.0928 3.50096C48.8009 2.20896 49.7159 0 51.543 0H67.9492C69.0818 0 70 0.918203 70 2.05078V18.457C70 20.2841 67.791 21.1991 66.499 19.9072L62.6463 16.0545ZM53.6866 44.9857L62.6464 53.9455L66.4992 50.0928C67.791 48.8009 70 49.7159 70 51.543V67.9492C70 69.0818 69.0818 70 67.9492 70H51.543C49.7159 70 48.8009 67.791 50.0928 66.499L53.9455 62.6463L44.9857 53.6864C48.6721 51.7087 51.7087 48.672 53.6866 44.9857Z"
          fill="url(#paint1_linear_713_11356)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_713_11356"
          x1="35"
          y1="56.1914"
          x2="35"
          y2="13.8086"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={palette[2]} />
          <stop offset="1" stopColor={palette[3]} />
        </linearGradient>
        <linearGradient
          id="paint1_linear_713_11356"
          x1="35"
          y1="70"
          x2="35"
          y2="0"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={palette[0]} />
          <stop offset="1" stopColor={palette[1]} />
        </linearGradient>
        <clipPath id="clip0_713_11356">
          <rect width="70" height="70" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

CashFlowSvg.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  palette: PropTypes.arrayOf(PropTypes.string),
};

export default CashFlowSvg;
